module.exports = __webpack_public_path__ + "static/media/clear-dark-icon.6f721ee9.svg";